<div class="about-container">
  <h2>À propos de {{ userData?.publicName }}</h2>
  
  <div class="info-section">
    <div class="info-item">
      <mat-icon>person</mat-icon>
      <span>{{ userData?.publicName }}</span>
    </div>
    
    <div class="info-item">
      <mat-icon>description</mat-icon>
      <span>{{ userData?.description || 'Aucune description' }}</span>
    </div>
    
    <div class="info-item">
      <mat-icon>location_on</mat-icon>
      <span>{{ userData?.ville || 'Aucune ville' }}</span>
    </div>
    
    <div class="info-item">
      <mat-icon>email</mat-icon>
      <span>{{ userData?.email }}</span>
    </div>
    
    <div class="info-item">
      
      <span>Membre depuis {{ formatDate(userData?.createdAt) }}</span>
    </div>
  </div>
</div>
